<template>
    <TinymceEditor ref="editor" v-bind="$attrs" :value="value" :init="editorInit" v-on="$listeners" @onInit="onInit" />
</template>

<script>
import GlobalsMixin from '@/mixins/globals';
/**
 * Wraps a tinymce field and configures it for the "zitat" template only.
 *
 * Inserts the template if the given value is not yet filled.
 *
 * Depending on the given type, the correct field is rendered.
 *
 * All additional props / listeners are passed to the child component.
 */
export default {
    name: 'ZitatBlockField',
    mixins: [GlobalsMixin],
    props: {
        init: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        value: {
            type: String,
            default: '',
        },
    },

    computed: {
        editorInit() {
            let tplEditInit = {
                toolbar1:
                    'bold italic underline strikethrough | subscript superscript |  link unlink | fullscreen code',
                toolbar2: '',
            };
            return Object.assign(tplEditInit, this.init);
        },
    },

    methods: {
        getZitatTemplate() {
            let templates = this.globalParam('html_editor_templates') || [];
            for (let z of templates) {
                if (z.ident === 'zitat') {
                    return z;
                }
            }
            return null;
        },

        onInit(ev, editor) {
            if (editor) {
                this.fillDefaultTemplate(editor);
            }
        },

        fillDefaultTemplate(editor) {
            // let editor = this.$refs.editor.getTinyMCEEditor();
            let zitatTpl = this.getZitatTemplate();
            if (zitatTpl && zitatTpl.content) {
                if (!this.value) {
                    editor.execCommand('mceInsertTemplate', false, zitatTpl.content);
                }
            }
        },
    },
};
</script>
